module.exports = __webpack_public_path__ + "static/media/1_A1_21.30dde37b.png";